<!--  -->
<template>
  <div>
    <!-- Hero Slider Start -->
    <section class="hero-slider-section">
        <div class="hero-slider owl-carousel">
            <!-- Single Slider item  -->
            <div class="single-slide bg-img d-flex align-items-center" v-for="(article,index) in articles" :key="index"  :data-bg-image="`${global.remoteIp}/uploads/${article.picsrc}`">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="slider-content">
                                <div class="sub animated">{{article.description}}</div>
                                <h3 class="animated">
                                    {{article.title}}
                                </h3>
                                <router-link :to="`/views/info/${article.plateid}/${article._id}`" class="animated bisylms-btn-3">详情</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Single Slider item  -->
        </div>
    </section>
    <!-- Hero Slider End -->
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  data () {
    return {
        articles:[],
        global
    };
  },
  props: {
    plates:Array
  },
  mounted() {
    let strplate = "";
    for (var i = 0; i < this.plates.length; i++) {
        if(this.plates[i].name=="新闻动态"){
            strplate = this.plates[i]._id;
        }
    }
    this.$axios.get(`/api/articles?plateid=${strplate}&page=1&limit=3&sort=-createdAt`).then(res => {
        if(res.data)
        {
            this.articles=res.data.data;
            this.$nextTick(function(){
                this.installOwlCarousel()
            })
        }
    });
  },
  methods: {
      installOwlCarousel(){
             if ($(".hero-slider").length > 0) {
                $('.hero-slider').owlCarousel({
                    loop: true,
                    margin: 0,
                    responsiveClass: true,
                    dots: false,
                    animateOut: 'fadeOut',
                    autoplayTimeout: 4500,
                    autoplay: true,
                    smartSpeed: 800,
                    center: false,
                    nav: true,
                    navText: ['<i class="arrow_carrot-left"></i>', '<i class="arrow_carrot-right"></i>'],
                    items: 1
                });
            }
            $('[data-bg-image]').each(function () {
                var $this = $(this),
                    $image = $this.data('bg-image');
                $this.css('background-image', 'url(' + $image + ')');
            });
      }
  }
}
</script>
<style scoped>
</style>